module.exports = __webpack_public_path__ + "static/media/home_simulacao_desktop.3327de56.png";